import { FormattedMessage } from 'react-intl';

import AccountNameLength from '@/App/UserPreferences/GeneralTab/AccountNameLength.tsx';
import AutoCloseGrowlAfter from '@/App/UserPreferences/GeneralTab/AutoCloseGrowlAfter.tsx';
import DateInputFormat from '@/App/UserPreferences/GeneralTab/DateInputFormat.tsx';
import { ShowColoredPrices } from '@/App/UserPreferences/GeneralTab/ShowColoredPrices.tsx';

export const GeneralTab = () => {
  return (
    <div className="overflow-y-auto">
      <p className="mt-1 mb-2">
        <FormattedMessage id="userPreferences.section.displayPreferences" />
      </p>

      <div className="border">
        <DateInputFormat />
        <AccountNameLength />
        <ShowColoredPrices />
      </div>

      <p className="mt-4 mb-2">
        <FormattedMessage id="userPreferences.section.tradePreferences" />
      </p>

      <div className="border">
        <AutoCloseGrowlAfter />
        {/* <OneClickExecution /> useless should be removed in forex ( check database ) */}
      </div>
    </div>
  );
};
